import type { MtAnimalBuyerGetAnimalQuery } from '@gql/graphql';
import { BirthdayType } from '@gql/graphql';
import type { BuyerAnimalFormValues } from '@presentation/components';
import dayjs from 'dayjs';
import { useCallback } from 'react';

export const useAnimalInitialValuesBuilder = () => {
  const animalInitialValuesBuilder = useCallback(
    (
      animal?: NonNullable<MtAnimalBuyerGetAnimalQuery['accountMe']>['animals'][number],
    ): BuyerAnimalFormValues => {
      if (!animal)
        return {
          birthdayType: BirthdayType.DATE,
          birthday: undefined,
          dogInfo: {
            breedId: undefined,
            medicalAffections: undefined,
            pedigree: undefined,
            pedigreeNumber: undefined,
            physicalCondition: undefined,
          },
          gender: undefined,
          images: [undefined],
          name: undefined,
          size: undefined,
          sterilized: undefined,
          type: undefined,
          calved: undefined,
          sensitivities: undefined,
        };

      const images = (animal.imgs ?? [])
        .filter((img) => !!img.medium)
        .map((img) => img.medium as string);

      return {
        images: !images.length ? [undefined] : images,
        sterilized: animal.sterilized ?? undefined,
        calved: animal.calved ?? undefined,
        gender: animal.gender ?? undefined,
        size: animal.size ?? undefined,
        birthdayType: animal.birthdayType ?? BirthdayType.DATE,
        type: animal.type ?? undefined,
        name: animal.name ?? undefined,
        birthday: animal.birthday ? dayjs(animal.birthday) : undefined,
        sensitivities: animal.sensitivities?.filter((x) => !!x) ?? undefined,

        ...(animal.dogInfos == null
          ? {
              dogInfo: {
                breedId: undefined,
                medicalAffections: undefined,
                pedigree: undefined,
                physicalCondition: undefined,
              },
            }
          : {
              dogInfo: {
                physicalCondition: animal.dogInfos.physicalCondition ?? undefined,
                pedigree:
                  animal.dogInfos.pedigree !== undefined ? animal.dogInfos.pedigree : undefined,
                breedId: animal.dogInfos.dogBreed?.id ?? undefined,
                medicalAffections: (animal.dogInfos.medicalAffections ?? []).map(
                  (affection) => affection.affectionType,
                ),
              },
            }),
      };
    },
    [],
  );

  return { animalInitialValuesBuilder };
};
